import React, {useState} from 'react';
import {translate} from '../Services/translation'
import {get} from '../Services/http'
import {showLoadSpinner, hideLoadSpinner} from '../loadSpinner';

const GeneratePdfButton = ({variantId}) => {
    const [errorMsg, setErrorMsg] = useState()

    const onClick = async () => {
        showLoadSpinner();
        try {
            await get("/api/pdfGenerator?id=" + variantId).then((resp) => resp.blob()).then((myBlob) => {
                window.open(URL.createObjectURL(myBlob))
            })
            hideLoadSpinner();
            setErrorMsg(null)

        } catch (error) {
            error.response.text().then(x => setErrorMsg(x))
            hideLoadSpinner();
        }
    }

    return (
        <>
            <a onClick={() => onClick()}
               className="product-detail__article-files-area-item-header-title">
                {translate('product.pdf.downloadbuttontext')}
            </a>
            {errorMsg && <p className="product-detail__download-product-pdf__error">{errorMsg} </p>}
        </>

    )
}
export default GeneratePdfButton;